/*jshint ignore: start*/
(function() {
	function Assets()
	{
		this.EventDispatcher_constructor();
		this._activeQueues = [];
		this.activeQueue = null;
		this._soundFileExtRegex = /\.mp3|\.ogg/g;

		this.compositionsIDMap = {};

		this.data = {};
		this.lib = {};

		this._loadedManifests = [];

		window.images = this.lib;
	}

	var p = cjs.extend(Assets, cjs.EventDispatcher);


	p.setAssetsDictionary = function( dataObject )
	{
		this.assetsDictionary = dataObject;
	};

	p.unloadAsset = function(id)
	{
		console.log("Unload: " + id);
		delete this.lib[id];
	};

	// Load in content from a manifest
	//cm.Assets.load(cm.AssetsManifest.manifests.load, this.FUNCTION.bind(this));
	p.load = function(manifests, onComplete, onError, onProgress)
	{

		if (window.springroll) {
			// Temporary hax 
			var sound = window.springroll.Application.instance.sound;
			for (var i = 0, l = manifests.length; i < l; i++) {
				for (var j = 0, jl = manifests[i].length; j < jl; j++) {
					if (this._soundFileExtRegex.test(manifests[i][j].src)) {
						manifests[i][j].src = manifests[i][j].src.replace(this._soundFileExtRegex, sound.supportedSound);
					}
				}
			}
		}

		// manifests = this._getManifestArray(manifests);
		if(!manifests) return;

		// Create queue
		var queue = new cjs.LoadQueue();
		queue.installPlugin(cjs.Sound);
		queue.registerLoader(cjs.FlashAnimationLoader);
		queue.setMaxConnections(10);
		queue.onComplete = onComplete;
		queue.onError = onError;
		queue.onProgress = onProgress;

		queue.on("complete", this._handleComplete, this);
		queue.on("error", this._handleError, this);
		queue.on("progress", this._handleProgress, this);
		queue.on("fileload", this._handleFileLoad, this);


		for (var i = 0; i < manifests.length; i++) {
			queue.loadManifest(manifests[i], false);
		}

		this.activeQueue = queue;
		// Load the data
		queue.load();
	};

	p._handleComplete = function(e)
	{	
		var queue = e.target;
		queue.onComplete(e);

		// Clean up loader for GC
		queue.removeAllEventListeners();
		queue.destroy();
		queue.removeAll();

		this.activeQueue = null;
	};

	p._handleError = function(e)
	{
		var q = e.target;
		if(q.onError) q.onError(e);
	};

	p._handleProgress = function(e)
	{	

		var q = e.target;
		if(q.onProgress) q.onProgress(e);
	};

	p.getCurrentProgress = function() {
		if (this.activeQueue) {
			return this.activeQueue.progress;
		} else {
			return null;
		}
	};

	p._handleFileLoad = function(e)
	{	

		var item = e.item;
		switch(item.type)
		{
			case cjs.LoadQueue.JAVASCRIPT:
				break;
			case "flash_animation":
				this.lib[item.id] = e.item.comp.getLibrary();
				console.log(item.id, this.lib[item.id]);
				break;
			case cjs.LoadQueue.SOUND:
				if (window.springroll) {
					// Hax to get around using the springroll sound loader.
					cm.app.sound._markLoaded({data: {id: item.id}});
				}
				break;
			default:
				this.lib[item.id] = e.result;
				break;
		}
	};

	// Unload a manifest from memory
	p.unload = function(manifests)
	{
		// manifests = this._getManifestArray(manifests);
		if(!manifests) return;

		// Load manifests to queue
		for (var i = 0; i < manifests.length; i++)
		{
			var m = manifests[i];
			if(m) this._unloadManifest(m);
		}
	};

	p._unloadManifest = function(manifest)
	{
		if(!Array.isArray(manifest))
			manifest = manifest.manifest;

		var soundsArray = [];

		// Go through all the assets on the manifest and delete based on types
		for (var i = 0, l = manifest.length; i < l; i++)
		{
			var item = manifest[i];

			// Delete flash spritesheet data from window
			if (item.type === "flash_animation" && item.lib && item.lib.properties.manifest)
			{
				this._unloadManifest(item.lib.properties.manifest);

				delete item.comp;
				delete item.lib;
			}
			else if(item.type === "sound")
			{

				if (window.springroll) {
					window.springroll.Application.instance.sound.unload([item.id]);
				} else {
					cjs.Sound.removeSound(item.id);
				}
			}

			this.unloadAsset(item.id);
		}

		// Remove sounds that were on the manifest
		cjs.Sound.removeSounds(soundsArray);
	};

	p._getManifestArray = function( arg )
	{
		var manifests;

		if(Array.isArray(arg))
		{
			manifests = [];
			for (var i = 0; i < arg.length; i++) {
				var str = arg[i];
				if(typeof str === "string")
					manifests.push(this._getManifestByString(str));
				else
					manifests.push(str);
			}

			return manifests;
		}

		if(typeof arg === "string") {
			return [this._getManifestByString(arg)];
		}

		return false;
	};

	p._getManifestByString = function(str)
	{
		return this.assetsDictionary[str];
	};

	var AssetsClass = createjs.promote(Assets, "EventDispatcher");
	cm.Assets = new AssetsClass();

})();
/*jshint ignore: end*/